import React, { useState } from "react";
import { Layout, Menu, Avatar, Badge, Dropdown } from "antd";
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  AppstoreOutlined,
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  BellOutlined,
  MailOutlined,
  UnorderedListOutlined,
  EditOutlined,
  PlusOutlined,
  UploadOutlined,
  BranchesOutlined,
} from "@ant-design/icons";
import { Link, Outlet, useNavigate } from "react-router-dom";
import logo from "../../assets/images/smartdeal-logo-tamni.png"; // Logo
import "./AdminDashboard.css"; // CSS fajl za stilizaciju

const { Header, Sider, Content } = Layout;

const AdminDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  // Funkcija za logout
  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/login");
  };

  // Dropdown meni za korisnika
  const userMenu = (
    <Menu>
      <Menu.Item key="0">
        <Link to="/admin/profil">Profil</Link>
      </Menu.Item>
      <Menu.Item key="1" onClick={handleLogout} icon={<LogoutOutlined />}>
        Odjava
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        theme="dark"
        style={{
          backgroundColor: "#12161c",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div>
          {/* Logo */}
          <div
            style={{
              textAlign: "center",
              padding: "16px",
              backgroundColor: "#12161c",
            }}
          >
            <img src={logo} alt="SmartDeals" style={{ width: "150px" }} />
          </div>

          {/* Navigacija */}
          <Menu
            theme="dark"
            mode="inline"
            style={{ backgroundColor: "#12161c", color: "white" }}
          >
            <Menu.Item key="1" icon={<DashboardOutlined />}>
              <Link to="/admin" style={{ color: "white" }}>
                Početna
              </Link>
            </Menu.Item>

            {/* Dropdown za proizvode */}
            <Menu.SubMenu key="2" icon={<AppstoreOutlined />} title="Proizvodi">
              <Menu.Item key="2-1" icon={<UnorderedListOutlined />}>
                <Link to="/admin/proizvodi">Lista</Link>
              </Menu.Item>
              <Menu.Item key="2-2" icon={<EditOutlined />}>
                <Link to="/admin/proizvodi/izmena">Izmena</Link>
              </Menu.Item>
              <Menu.Item key="2-3" icon={<PlusOutlined />}>
                <Link to="/admin/proizvodi/dodaj">Dodaj novi</Link>
              </Menu.Item>

              <Menu.Item key="2-4" icon={<UploadOutlined />}>
                <Link to="/admin/proizvodi/import">Import</Link>
              </Menu.Item>
            </Menu.SubMenu>

            <Menu.Item key="3" icon={<ShoppingCartOutlined />}>
              <Link to="/admin/porudzbine" style={{ color: "white" }}>
                Porudžbine
              </Link>
            </Menu.Item>
            <Menu.Item key="4" icon={<UserOutlined />}>
              <Link to="/admin/korisnici" style={{ color: "white" }}>
                Korisnici
              </Link>
            </Menu.Item>
            <Menu.Item key="5" icon={<SettingOutlined />}>
              <Link to="/admin/podesavanja" style={{ color: "white" }}>
                Podešavanja
              </Link>
            </Menu.Item>
          </Menu>
        </div>
      </Sider>

      {/* Glavni sadržaj */}
      <Layout>
        <Header
          style={{
            background: "#fff",
            padding: "10px 20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
          }}
        >
          <h2 style={{ margin: 0, color: "#12161c" }}>Admin Panel</h2>

          {/* Desni deo zaglavlja */}
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <Badge count={2}>
              <BellOutlined
                style={{ fontSize: "20px", cursor: "pointer", color: "#333" }}
              />
            </Badge>
            <Badge count={3}>
              <MailOutlined
                style={{ fontSize: "20px", cursor: "pointer", color: "#333" }}
              />
            </Badge>
            <Dropdown overlay={userMenu} trigger={["click"]}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Avatar src="https://via.placeholder.com/40" />
                <span style={{ marginLeft: "8px", fontWeight: "500" }}>
                  Tomic Milos
                </span>
              </div>
            </Dropdown>
          </div>
        </Header>
        <Content
          style={{
            margin: "16px",
            padding: "16px",
            background: "#fff",
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminDashboard;
